export const eventTimeStampToRelative = (): DOMHighResTimeStamp => {
  const startTime = performance.now();
  return startTime > performance.timeOrigin
    ? startTime - performance.timeOrigin
    : startTime;
};
